import React, { Component } from "react";

import Header2 from "parts/Header2";
import HeroTeam2 from "parts/HeroTeam2";
import AllTeam2 from "parts/AllTeam2";
import Footer2 from "parts/Footer2";

import { TeamMembers } from "json/landingPageData2";

export default class TeamPage2 extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header2 />
        <HeroTeam2 />
        <AllTeam2 data={TeamMembers} />
        <Footer2 />
      </>
    );
  }
}
